<div cdkDrag cdkDragBoundary=".cdk-overlay-container"
     cdkDragRootElement=".dialog-box.welcome">
  <div cdkDragHandle mat-dialog-title>
    <!--    <mat-icon i18n-matTooltip matTooltip="">info-->
    <!--    </mat-icon>-->
    <h1>{{ globals.titles.welcome }}</h1>
    <app-close-button [data]="closeData"></app-close-button>
  </div>
  <mat-dialog-content>
    <div i18n>
      This is a webapp to play Tacta, a card game by Jason Tremblay, USAopoly.
    </div>
    @if (bs.serviceAvailable) {
      @if (bs.remainingUsers > 0) {
        <div>
          <span i18n>To use this app you need to</span>
          <button (click)="mode='login'" [class]="classForLogin" i18n mat-button>login</button>
          <span i18n>or</span>
          <button (click)="mode='register'" [class]="classForRegister" i18n mat-button>register</button>
        </div>
      } @else {
        <div>
          <span i18n>To use this app you need to login</span>
        </div>
      }
      <form [formGroup]="form">
        <mat-form-field [appearance]="globals.appearance" [formGroup]="form">
          <mat-label>{{ controls['username']?.label }}</mat-label>
          <input autocapitalize="none" autocomplete="off" formControlName="username" id="username" matInput>
        </mat-form-field>
        <mat-form-field [appearance]="globals.appearance" [formGroup]="form">
          <mat-label>{{ controls.password.label }}</mat-label>
          <input [type]="hide ? 'password' : 'text'" formControlName="password" id="password" matInput/>
          <button
            (click)="clickHide($event)"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide"
            mat-icon-button
            matSuffix
            type="button">
            <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <!-- mat-error *ngIf="form.get('password')?.invalid && !form.get('password')?.untouched">
            <ng-container *ngIf="form.get('password')?.errors?.['required']" i18n>Password is required</ng-container>
          </mat-error -->
        </mat-form-field>
        @if (bs.remainingUsers > 0) {
          <div [class]="classForArea('register')">
            <ng-container *ngTemplateOutlet="formFieldTemplate; context: {name: 'email'}"></ng-container>
            <br>
            <ng-container *ngTemplateOutlet="formFieldTemplate; context: {name: 'firstname'}"></ng-container>
            <ng-container *ngTemplateOutlet="formFieldTemplate; context: {name: 'lastname'}"></ng-container>
            <br>
            <ng-container *ngTemplateOutlet="formFieldTemplate; context: {name: 'address1'}"></ng-container>
            <ng-container *ngTemplateOutlet="formFieldTemplate; context: {name: 'address2'}"></ng-container>
            <br>
            <ng-container *ngTemplateOutlet="formFieldTemplate; context: {name: 'zip'}"></ng-container>
            <ng-container *ngTemplateOutlet="formFieldTemplate; context: {name: 'city'}"></ng-container>
          </div>
        }
      </form>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    @if (bs.serviceAvailable) {
      <button (click)="clickSend()" mat-button>{{ btnSendTitle }}</button>
    } @else {
      <div i18n>
        The service is currently not available
      </div>
    }
  </mat-dialog-actions>
</div>

<ng-template #formFieldTemplate let-name="name">
  <mat-form-field [appearance]="globals.appearance" [formGroup]="form">
    <mat-label>{{ controls[name]?.label }}</mat-label>
    <input [formControlName]="name" [id]="name" matInput>
  </mat-form-field>
</ng-template>

